/**
 * Execution Id is not currently wired up
 *
 * This is a placeholder for when it is asked for.
 *
 */

export function* executionIdLinkingSagas() {
    // yield all([takeEvery('userDoubleClickedOrderFromTable', handleUserSelectedOrder)]);
}
